import React from 'react';
import IEmployee from '../models/IEmployee';
import './employee.style.scss';
import Picture from '../../Picture';

interface IEmployeeProps extends IEmployee {
}

export default function Employee(props: IEmployeeProps) {
    const picture = process.env.GATSBY_MEDIA_URL + (props.picture ? props.picture.replace(/^\/media/i, '') : '/bio-images/bio-avatar.jpg');
    return (
        <div className="col-sm-12 col-md-6 col-lg-4 employee-card px-3 pb-4">
            <div className="bg-gray-200 h-100">
                <div>
                    <a href={props.bio}>
                        <Picture loading="lazy" className="w-100" alt={props.name} src={`${picture}`} />
                    </a>
                </div>
                <div className="p-4_5">
                    <div>
                        <h5 className="text-muted">{props.title}</h5>
                        <h2>{props.name}</h2>
                    </div>
                    <div className="mt-4 employee-contact">
                        <div>
                            <a className="text-dark font-weight-bold" href={`tel:${props.number}`}>{props.number}</a>
                        </div>
                        {props.fax && (
                            <div>
                                <a className="text-dark font-weight-bold" href={`fax:${props.fax}`}>{props.fax} (Fax)</a>
                            </div>)
                        }
                        <div>
                            <a className="text-dark" href={`mailto:${props.email}`}>{props.email}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
